(function (global) {
  'use strict';

  var STORAGE_KEY = 'jinhua_attribution_v1';
  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  var FIELD_KEYS = UTM_KEYS.concat(['landing_page', 'source_page', 'component_context']);
  var MAX_VALUE_LENGTH = 160;

  function sanitizeValue(value, maxLength) {
    var limit = Number(maxLength) > 0 ? Number(maxLength) : MAX_VALUE_LENGTH;
    return String(value == null ? '' : value)
      .replace(/[\u0000-\u001f\u007f]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .slice(0, limit);
  }

  function origin() {
    return global.location && global.location.origin ? global.location.origin : 'https://jinhuamach.com';
  }

  function normalizeSameSitePath(value) {
    if (!value) {
      return '';
    }
    try {
      var parsed = new URL(String(value), origin());
      if (parsed.origin !== origin() || !/^https?:$/.test(parsed.protocol)) {
        return '';
      }
      return sanitizeValue(parsed.pathname + parsed.search, MAX_VALUE_LENGTH);
    } catch (error) {
      return '';
    }
  }

  function readStored(storage) {
    var target = storage || global.sessionStorage;
    if (!target || typeof target.getItem !== 'function') {
      return {};
    }
    try {
      var parsed = JSON.parse(target.getItem(STORAGE_KEY) || '{}');
      return parsed && typeof parsed === 'object' ? parsed : {};
    } catch (error) {
      return {};
    }
  }

  function getAttribution(storage) {
    var stored = readStored(storage);
    var result = {};
    UTM_KEYS.forEach(function (key) {
      var value = sanitizeValue(stored[key], MAX_VALUE_LENGTH);
      if (value) {
        result[key] = value;
      }
    });
    var landingPage = normalizeSameSitePath(stored.landing_page);
    if (landingPage) {
      result.landing_page = landingPage;
    }
    return result;
  }

  function captureAttribution(locationLike, storage) {
    var target = storage || global.sessionStorage;
    if (!target || typeof target.setItem !== 'function') {
      return {};
    }

    var current = getAttribution(target);
    var href = locationLike && locationLike.href ? locationLike.href : global.location.href;
    var search = locationLike && typeof locationLike.search === 'string' ? locationLike.search : global.location.search;
    var pathname = locationLike && locationLike.pathname ? locationLike.pathname : global.location.pathname;
    var params;

    try {
      params = new URLSearchParams(search || new URL(href, origin()).search);
    } catch (error) {
      params = new URLSearchParams('');
    }

    UTM_KEYS.forEach(function (key) {
      if (!current[key]) {
        var value = sanitizeValue(params.get(key), MAX_VALUE_LENGTH);
        if (value) {
          current[key] = value;
        }
      }
    });

    if (!current.landing_page) {
      current.landing_page = normalizeSameSitePath(pathname || href) || '/';
    }

    target.setItem(STORAGE_KEY, JSON.stringify(current));
    return getAttribution(target);
  }

  function componentContextFromUrl(href) {
    try {
      var parsed = new URL(href || global.location.href, origin());
      var raw = parsed.searchParams.get('component_context') || parsed.searchParams.get('product') || parsed.searchParams.get('service') || '';
      return sanitizeValue(raw, 80)
        .toLowerCase()
        .replace(/[^a-z0-9._-]+/g, '-')
        .replace(/^-+|-+$/g, '');
    } catch (error) {
      return '';
    }
  }

  function decorateRfqUrl(href, context) {
    try {
      var parsed = new URL(href, origin());
      if (parsed.origin !== origin() || parsed.pathname !== '/pages/contact') {
        return href;
      }
      parsed.searchParams.set('rfq_intent', '1');
      var sourcePage = normalizeSameSitePath(context && context.sourcePage);
      var componentContext = sanitizeValue(context && context.componentContext, 80)
        .toLowerCase()
        .replace(/[^a-z0-9._-]+/g, '-')
        .replace(/^-+|-+$/g, '');
      var ctaLocation = sanitizeValue(context && context.ctaLocation, 40)
        .toLowerCase()
        .replace(/[^a-z0-9._-]+/g, '-')
        .replace(/^-+|-+$/g, '');
      if (sourcePage) {
        parsed.searchParams.set('source_page', sourcePage);
      }
      if (componentContext) {
        parsed.searchParams.set('component_context', componentContext);
      }
      if (ctaLocation) {
        parsed.searchParams.set('cta_location', ctaLocation);
      }
      return parsed.pathname + parsed.search + parsed.hash;
    } catch (error) {
      return href;
    }
  }

  function decorateEmailRfqUrl(href, context) {
    try {
      var parsed = new URL(href, origin());
      if (parsed.origin !== origin() || parsed.pathname !== '/pages/contact') {
        return href;
      }

      parsed.searchParams.set('email_rfq', '1');
      parsed.searchParams.set('email_action', 'drawings');

      var settings = context || {};
      var attribution = getAttribution(settings.storage || global.sessionStorage);
      UTM_KEYS.concat(['landing_page']).forEach(function (key) {
        var value = key === 'landing_page'
          ? normalizeSameSitePath(attribution[key])
          : sanitizeValue(attribution[key], MAX_VALUE_LENGTH);
        if (value) {
          parsed.searchParams.set(key, value);
        }
      });

      var sourcePage = normalizeSameSitePath(settings.sourcePage);
      var componentContext = sanitizeValue(settings.componentContext, 80)
        .toLowerCase()
        .replace(/[^a-z0-9._-]+/g, '-')
        .replace(/^-+|-+$/g, '');
      if (sourcePage) {
        parsed.searchParams.set('source_page', sourcePage);
      }
      if (componentContext) {
        parsed.searchParams.set('component_context', componentContext);
      }

      return parsed.pathname + parsed.search + parsed.hash;
    } catch (error) {
      return href;
    }
  }

  function safeSourcePage() {
    var params = new URLSearchParams(global.location.search || '');
    return normalizeSameSitePath(params.get('source_page')) || normalizeSameSitePath(document.referrer) || normalizeSameSitePath(global.location.pathname) || '/';
  }

  function applyHiddenFields(form, options) {
    if (!form || typeof form.querySelector !== 'function') {
      return {};
    }
    var settings = options || {};
    var values = getAttribution(settings.storage || global.sessionStorage);
    values.source_page = normalizeSameSitePath(settings.sourcePage) || safeSourcePage();
    values.component_context = sanitizeValue(settings.componentContext || componentContextFromUrl(global.location.href), 80)
      .toLowerCase()
      .replace(/[^a-z0-9._-]+/g, '-')
      .replace(/^-+|-+$/g, '');

    FIELD_KEYS.forEach(function (key) {
      var field = form.querySelector('[data-attribution-field="' + key + '"]');
      if (field) {
        field.value = sanitizeValue(values[key], MAX_VALUE_LENGTH);
      }
    });
    return values;
  }

  function classifyContactLink(href) {
    var value = String(href || '').toLowerCase();
    if (value.indexOf('tel:') === 0) {
      return { eventName: 'phone_click', linkLocation: 'telephone' };
    }
    if (value.indexOf('https://wa.me/') === 0 || value.indexOf('whatsapp.com') !== -1) {
      return { eventName: 'whatsapp_click', linkLocation: 'whatsapp' };
    }
    return null;
  }

  function publishIntent(eventName, details) {
    var payload = {
      source_page: normalizeSameSitePath(details && details.source_page) || normalizeSameSitePath(global.location.pathname) || '/',
      component_context: sanitizeValue(details && details.component_context, 80),
      cta_location: sanitizeValue(details && details.cta_location, 40),
      link_location: sanitizeValue(details && details.link_location, 40)
    };

    Object.keys(payload).forEach(function (key) {
      if (!payload[key]) {
        delete payload[key];
      }
    });

    if (global.Shopify && global.Shopify.analytics && typeof global.Shopify.analytics.publish === 'function') {
      global.Shopify.analytics.publish(eventName, payload);
      return true;
    }

    if (typeof document.dispatchEvent === 'function' && typeof global.CustomEvent === 'function') {
      document.dispatchEvent(new global.CustomEvent('jinhua:analytics-intent', {
        detail: { eventName: eventName, parameters: payload }
      }));
    }
    return false;
  }

  function closestLink(target) {
    if (!target) {
      return null;
    }
    if (typeof target.closest === 'function') {
      return target.closest('a[href]');
    }
    return null;
  }

  function onDocumentClick(event) {
    var emailLauncher = event.target && typeof event.target.closest === 'function'
      ? event.target.closest('[data-email-app-launch]')
      : null;
    if (emailLauncher) {
      var user = sanitizeValue(emailLauncher.getAttribute('data-email-user'), 80);
      var domain = sanitizeValue(emailLauncher.getAttribute('data-email-domain'), 120);
      var subject = sanitizeValue(emailLauncher.getAttribute('data-email-subject'), 120);
      if (user && domain) {
        global.location.href = 'mailto:' + user + '@' + domain + (subject ? '?subject=' + encodeURIComponent(subject) : '');
      }
      return;
    }

    var link = closestLink(event.target);
    if (!link) {
      return;
    }

    var rawHref = link.getAttribute('href') || '';
    if (link.hasAttribute('data-email-rfq-entry')) {
      link.setAttribute('href', decorateEmailRfqUrl(rawHref, {
        storage: global.sessionStorage,
        sourcePage: global.location.pathname,
        componentContext: componentContextFromUrl(global.location.href)
      }));
      return;
    }

    var classified = classifyContactLink(rawHref);
    if (classified) {
      publishIntent(classified.eventName, {
        source_page: global.location.pathname,
        link_location: classified.linkLocation
      });
      return;
    }

    try {
      var parsed = new URL(rawHref, origin());
      if (parsed.origin === origin() && parsed.pathname === '/pages/contact') {
        var context = componentContextFromUrl(parsed.href) || sanitizeValue(link.getAttribute('data-component-context'), 80);
        var ctaLocation = sanitizeValue(link.getAttribute('data-cta-location') || link.closest('[data-cta-location]') && link.closest('[data-cta-location]').getAttribute('data-cta-location') || 'link', 40);
        link.setAttribute('href', decorateRfqUrl(rawHref, {
          sourcePage: global.location.pathname + global.location.search,
          componentContext: context,
          ctaLocation: ctaLocation
        }));
        publishIntent('rfq_cta_click', {
          source_page: global.location.pathname,
          component_context: context,
          cta_location: ctaLocation
        });
      }
    } catch (error) {
      return;
    }
  }

  function init() {
    captureAttribution(global.location, global.sessionStorage);
    var emailRfqState = new URLSearchParams(global.location.search || '').get('email_rfq') === '1';
    var emailEntry = document.querySelector('[data-email-rfq-entry-panel]');
    var emailConfirmation = document.querySelector('[data-email-rfq-confirmation]');
    if (emailEntry) {
      emailEntry.hidden = emailRfqState;
    }
    if (emailConfirmation) {
      emailConfirmation.hidden = !emailRfqState;
    }
    var form = document.getElementById('contact_form');
    if (form) {
      applyHiddenFields(form, {
        storage: global.sessionStorage,
        sourcePage: safeSourcePage(),
        componentContext: componentContextFromUrl(global.location.href)
      });
    }
    document.addEventListener('click', onDocumentClick, false);
  }

  global.JinhuaLeadTracking = {
    sanitizeValue: sanitizeValue,
    normalizeSameSitePath: normalizeSameSitePath,
    captureAttribution: captureAttribution,
    getAttribution: getAttribution,
    componentContextFromUrl: componentContextFromUrl,
    decorateRfqUrl: decorateRfqUrl,
    decorateEmailRfqUrl: decorateEmailRfqUrl,
    applyHiddenFields: applyHiddenFields,
    classifyContactLink: classifyContactLink,
    publishIntent: publishIntent,
    init: init
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})(window);

